import { render, staticRenderFns } from "./login.vue?vue&type=template&id=c2965970&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=c2965970&prod&lang=scss&scoped=true"
import style1 from "./login.vue?vue&type=style&index=1&id=c2965970&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2965970",
  null
  
)

export default component.exports